import { Flex, Text,useToast } from '@chakra-ui/react'
import React, { useEffect, useMemo, useRef, useState } from 'react'
// import { errorHandle } from '../../api/api'
import { getAllQueues, getAllQueuesByName } from '../../classes/Queue'
import { useSearchQueryContext } from '../../context/searchQueryContext'
import SelectedItemAlertContext, { AL_INFO, defaultSelectData } from '../../context/selectedItemAlertContext'
import { useUserContext } from '../../context/userContext'
import {
    BadgeQueueNotifyStatus, BadgeQueueStatus, ExportToolsPanel, Table,
    TableButtonAdminQueueGroup
} from '../shared'
import ModalQueueInfo from './ModalQueueInfo'
import { toastErrDesc, toastVal } from '../../utils/toastUtils'

const TableResultTitle = () => {
    const { query } = useSearchQueryContext()
    // console.log(query)
    return (
        <Flex justify="left">
            {!query.search_all && <Text>อาคาร : <Text as="span" fontWeight="bold">{query.residence?.label}</Text> ระดับ : <Text as="span" fontWeight="bold">{query.queue_group?.label}</Text></Text> }
        </Flex>
    )
}

const TableAllQueues = () => {
    const toast = useToast()
    const { userData } = useUserContext()
    const [data, setData] = useState(null) // list record of queues
    const { query } = useSearchQueryContext()

    const columns = useMemo(() => {
        let cols = [
            {
                Header: 'ลำดับคิว',
                accessor: 'order'
            },
            {
                Header: 'ชื่อ',
                accessor: 'first_name'
            },
            {
                Header: 'นามสกุล',
                accessor: 'last_name'
            }
        ]

        if (query?.search_all) {
            // แสดงคอลัม อาคาร ตอนค้นทุกอาคาร
            cols.push({
                Header: 'อาคาร',
                accessor: 'residence_name'
            })
        } else {
            // แสดงคอลัม ตำแหน่ง ตอนค้นรายอาคาร
            cols.push({
                Header: 'ตำแหน่ง',
                accessor: 'position_name'
            })
        }

        // วันที่ยื่น ยื่นเวลา
        cols = [...cols,
        {
            Header: 'วันที่ยื่น',
            accessor: 'submit_date',
        },
        {
            Header: 'ยื่นเวลา',
            accessor: 'submit_time',
        }
        ]

        if (userData.isAcceptRoles([1, 2])) {
            cols.push(
                {
                    Header: 'สถานะ',
                    accessor: 'queue_status_id',
                    Cell: ({ value }) => (<BadgeQueueStatus status={value} />),
                    // Filter: SelectColumnFilter,
                    // filter: 'includes',
                },
                {
                    Header: 'แจ้งนัด',
                    accessor: 'appointment_date',
                    Cell: ({ value }) => (<BadgeQueueNotifyStatus value={value} />)
                },
                {
                    Header: 'จัดการ',
                    Cell: ({ row }) => (<TableButtonAdminQueueGroup row={row.original} />)
                },
            )
        }
        return cols
    }, [userData, query?.search_all])

    const [itemData, setItemData] = useState(defaultSelectData)

    const loadData = useRef()
    loadData.current = async () => {
        if (query) {
            if (query.search_all) {
                // search all
                await getAllQueuesByName(query.name, userData.token)
                    .then(res => {
                        const fileName = `ค้นด้วยชื่อ_${query.name || '-'}`
                        const rs = {}
                        rs.table = res
                        rs.export = {
                            excel: {
                                data: res.map(i => i.export()),
                                fileName: fileName
                            }
                        }
                        setData(rs)
                    })
                    .catch(error => {
                        // console.log('error')
                        // console.log(errorHandle(error))
                        toast(toastVal({
                            title: "การดึงข้อมูล ไม่สำเร็จ",
                            description: toastErrDesc(error),
                            status: "error",
                        }))
                    })
            } else {
                // search by residence (normal)
                const q = query?.serialized()
                await getAllQueues(q)
                    .then(res => {
                        const fileName = `คิว_${query.residence?.label}_${query.queue_group?.value || 0}`
                        // console.log('all queue')
                        // console.log(res)
                        if (query.name) {
                            const filtered = res.filter(i => {
                                const fullname = `${i.first_name} ${i.last_name}`
                                return fullname.includes(query.name)
                            })
                            const rs = {}
                            rs.table = filtered
                            rs.export = {
                                excel: {
                                    data: filtered.map(i => i.export()),
                                    fileName: fileName
                                }
                            }
                            setData(rs)
                        } else {
                            const rs = {}
                            rs.table = res
                            rs.export = {
                                excel: {
                                    data: res.map(i => i.export()),
                                    fileName: fileName
                                }
                            }
                            setData(rs)
                        }
                    })
                    .catch(error => {
                        // console.log('error')
                        // console.log(errorHandle(error))
                        toast(toastVal({
                            title: "การดึงข้อมูล ไม่สำเร็จ",
                            description: toastErrDesc(error),
                            status: "error",
                        }))
                    })
            }

        }
    }
    // console.log('render table all queues')
    // console.log(query)
    // console.log(itemData?.reload)
    useEffect(() => {
        loadData.current()
    }, [query, itemData?.reload])

    return (
        <SelectedItemAlertContext.Provider value={[itemData, setItemData]} >
            {data && <ExportToolsPanel options={data?.export} >
                <TableResultTitle />
            </ExportToolsPanel>}

            {data && <Table columns={columns} data={data?.table} />}
            {itemData?.type === AL_INFO && <ModalQueueInfo data={itemData} />}
        </SelectedItemAlertContext.Provider>
    )
}

export default TableAllQueues
